<template>
  <div>
    <article v-if="inputLabel()" class="form-control-label">
      {{ inputLabel() }}
    </article>
    <v-text-field
      :label="label && label.length <= 25 ? label : null"
      persistent-placeholder
      :type="type"
      v-model="computedValue"
      outlined
      :hide-details="hideDetails"
      :required="required"
      :placeholder="placeholder"
      class="os-rounded"
      @keyup="$emit('keyup', $event)"
      :error-messages="errorMessages"
      :error="error"
      @blur="$emit('blur', $event)"
      :dense="dense"
      :disabled="disabled"
      :loading="loading"
    ></v-text-field>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0,
      required: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: 'primary'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  methods: {
    inputLabel() {
      return this.label.length > 25 ? this.label : null
    }
  }
}
</script>
